export default {
      id: "comments-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons-sprite.c706496.svg#comments-usage",
      toString: function () {
        return this.url;
      }
    }